<p-card header="Winning Bets Report">
  <label htmlFor="code" style="font-size: large; font-weight: bold"
    >Select Date:
  </label>
  <p-calendar
    [(ngModel)]="date"
    [showIcon]="true"
    class="ml-2"
    (onSelect)="LoadGross()"
  ></p-calendar>
  <!-- <p-button label="Load" class="ml-3" (onClick)="LoadGross()"></p-button> -->
  <div class="card mt-4">
    <p-table
      #dt
      [value]="winningbets"
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="10"
    >
      <ng-template pTemplate="caption">
        <div class="flex">
          <button
            type="button"
            pButton
            pRipple
            icon="pi pi-file-excel"
            (click)="exportExcel()"
            class="p-button-success mr-2"
            pTooltip="XLS"
            tooltipPosition="bottom"
          ></button>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <!-- <th>Date</th> -->
          <th>Usercode</th>
          <th>Game</th>
          <th>Time</th>
          <th>Combination</th>
          <th>Total Bet</th>
          <th>Total Winning</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-bets>
        <tr>
          <!-- <td>{{ bets.drawdate }}</td> -->
          <td>{{ bets.usercode }}</td>
          <td>{{ bets.drawtype }}</td>
          <td>{{ bets.drawtime }}</td>
          <td>{{ bets.combination }}</td>
          <td>{{ bets.TotalBet }}</td>
          <td>{{ bets.TotalWinningPrize }}</td>
          <!-- <td>
                <p-button
                  class="mx-1"
                  icon="pi pi-user-edit"
                  styleClass="p-button-rounded p-button-warning"
                ></p-button>
                <p-button
                  icon="pi pi-trash"
                  styleClass="p-button-rounded p-button-danger"
                ></p-button>
              </td> -->
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="6">No data found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>

<p-dialog header="ADD" [(visible)]="visible" [style]="{ width: '50vw' }">
  <div class="grid">
    <div class="col-6">
      <div class="flex flex-column gap-2">
        <label htmlFor="code">Code</label>
        <input
          pInputText
          id="code"
          aria-describedby="code-help"
          [(ngModel)]="Code"
        />
      </div>
    </div>
    <div class="col-6">
      <div class="flex flex-column gap-2">
        <label htmlFor="name">Name</label>
        <input
          pInputText
          id="name"
          aria-describedby="name-help"
          [(ngModel)]="Name"
        />
      </div>
    </div>
    <!-- <div class="col-4">
            <div class="flex flex-column gap-2">
              <label htmlFor="">Lastname</label>
              <input
                pInputText
                id="lastname"
                aria-describedby="username-help"
                [(ngModel)]="value"
              />
            </div>
          </div> -->
  </div>
  <div class="flex flex-row-reverse flex-wrap">
    <button
      pButton
      pRipple
      label="SAVE"
      class="p-button-info mt-3 ml-2"
    ></button>
  </div>
</p-dialog>
